var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#FF6633"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0039 8.27717L11 6.21038L11.9961 8.27717C12.2715 8.84866 12.8239 9.21963 13.4346 9.28893L15.6995 9.54594L14.057 10.9997L14.7197 11.7486L14.057 10.9997C13.5858 11.4167 13.3615 12.0541 13.4922 12.6837L13.9398 14.8397L11.8742 13.7331C11.3295 13.4413 10.6705 13.4413 10.1258 13.7331L8.06021 14.8397L8.50783 12.6837C8.63854 12.0541 8.41419 11.4167 7.94302 10.9997L6.30045 9.54594L8.56537 9.28893C9.1761 9.21963 9.72849 8.84866 10.0039 8.27717L9.10308 7.84301L10.0039 8.27717ZM5.928 9.2163C5.92804 9.21634 5.92809 9.21637 5.92813 9.21641L5.928 9.2163Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalPoints);
export default __webpack_public_path__ + "static/media/TotalPoints.4bb84b3d60cf70abd441947430d58e95.svg";
export { ForwardRef as ReactComponent };